import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withState } from 'recompose'
import qs from 'query-string'
import isMobile from 'ismobilejs'

import config from 'config'
import { isExtensionInstalled } from 'utils/extension'

import * as OrgSelectors from 'modules/org/selectors'
import * as UserActions from 'modules/user/actions'

import VideoController from './component'

const mapStateToProps = state => ({
  orgId: OrgSelectors.getOrgId(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchUser: UserActions.fetchUser,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('loginUrl', 'setLoginUrl', `${config.START_WEB_URL}/login`),
  lifecycle({
    async componentDidMount() {
      if (!this.props.orgId) {
        this.props.actions.fetchUser()
      }
      
      let redirect
      const hasExtension = await isExtensionInstalled()
      
      if (isMobile.any) {
        redirect = `${config.LETS_GO_URL}/letsgo/video/success`
      } else if (hasExtension) {
        redirect = `${config.LETS_GO_URL}/letsgo/video/landing`
      } else {
        redirect = `${config.LETS_GO_URL}/letsgo/video/extension`
      }
      this.props.setLoginUrl(`${config.START_WEB_URL}/login?${qs.stringify({ redirect })}`)
    },
  }),
)(VideoController)



// WEBPACK FOOTER //
// ./src/layouts/VideoController/index.js